type PluralizeTextsKey =
  | 'age'
  | 'drivers'
  | 'driversGenitive'
  | 'presents'
  | 'offices'
  | 'payments'
  | 'reviews'
  | 'days'
  | 'months'
  | 'years'
  | 'credits'
  | 'cards';

export const PluralizeTexts: Record<PluralizeTextsKey, [string, string, string]> = {
  age: ['год', 'года', 'лет'],
  drivers: ['водитель', 'водителя', 'водителей'],
  driversGenitive: ['водителя', 'водителей', 'водителей'], // Родительный падеж
  presents: ['подарок', 'подарка', 'подарков'],
  offices: ['офис', 'офиса', 'офисов'],
  payments: ['платёж', 'платежа', 'платежей'],
  reviews: ['отзыв', 'отзыва', 'отзывов'],
  days: ['день', 'дня', 'дней'],
  months: ['месяц', 'месяца', 'месяцев'],
  years: ['год', 'года', 'лет'],
  credits: ['кредит', 'кредита', 'кредитов'],
  cards: ['карта', 'карты', 'карт'],
};
